var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import CustomiseModal from './CustomiseModal';
import { getURLParam } from '../helpers/urlParams';
const Customiser = ({ customiserButtonSelector, customiserContainerSelector, preloadContext }) => {
    const [modalDisplay, setModalDisplay] = useState(false);
    const [context, setContext] = useState(preloadContext);
    const [modalKey, setModalKey] = useState(0);
    const [currentVariantObject, setCurrentVariantObject] = useState(null);
    const [currentFilterOptions, setCurrentFilterOptions] = useState(null);
    const buttonHandler = () => {
        setModalDisplay(!modalDisplay);
        // toggle overflow hidden on body
        document.body.classList.toggle('modal-lock');
        if (!modalDisplay) {
            setModalKey((prevKey) => prevKey + 1); // Increment key to force reload the modal
        }
    };
    useEffect(() => {
        if (!preloadContext) {
            const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
                const productHandle = document.querySelector(customiserButtonSelector).dataset.product;
                const fetchedContext = yield fetch(`${window.Shopify.routes.root}products/${productHandle}?view=customiser.json`).then((data) => data.json());
                setContext(fetchedContext);
            });
            fetchData();
        }
        let currentVariant = getURLParam('variant');
        if (!currentVariant) {
            currentVariant = document.querySelector(customiserButtonSelector).dataset.currentVariant;
        }
        const currentVarObj = context.product.variants.filter((variant) => variant.id == currentVariant)[0];
        const sizeOption = context.product.options.find((option) => option.name == 'Size');
        const colorOption = context.product.options.find((option) => option.name == 'Colour');
        let currentFilterOpt = context.product.variants.filter((variant) => variant.options[sizeOption.position - 1] == currentVarObj.options[sizeOption.position - 1]);
        if (colorOption) {
            currentFilterOpt = currentFilterOpt.filter((variant) => variant.options[colorOption.position - 1] == currentVarObj.options[colorOption.position - 1] &&
                variant.options[sizeOption.position - 1] == currentVarObj.options[sizeOption.position - 1]);
        }
        setCurrentVariantObject(currentVarObj);
        setCurrentFilterOptions(currentFilterOpt);
        return () => {
            document.body.classList.remove('modal-lock');
        };
    }, [customiserButtonSelector, customiserContainerSelector, preloadContext]);
    useEffect(() => {
        const variantBtns = document.querySelectorAll('.variant__button-label');
        if (variantBtns) {
            variantBtns.forEach((btn) => {
                btn.addEventListener('click', () => {
                    setTimeout(() => {
                        let newVariant = getURLParam('variant');
                        const currentVarObj = context.product.variants.filter((variant) => variant.id == newVariant)[0];
                        const sizeOption = context.product.options.find((option) => option.name == 'Size');
                        const colorOption = context.product.options.find((option) => option.name == 'Colour');
                        let currentFilterOpt = context.product.variants.filter((variant) => variant.options[sizeOption.position - 1] == currentVarObj.options[sizeOption.position - 1]);
                        if (colorOption) {
                            currentFilterOpt = currentFilterOpt.filter((variant) => variant.options[colorOption.position - 1] == currentVarObj.options[colorOption.position - 1] &&
                                variant.options[sizeOption.position - 1] == currentVarObj.options[sizeOption.position - 1]);
                        }
                        setCurrentVariantObject(currentVarObj);
                        setCurrentFilterOptions(currentFilterOpt);
                    }, 300);
                });
            });
        }
    }, []);
    if (!context || !currentVariantObject) {
        return (React.createElement("button", { disabled: true, className: "btn btn--full hg-modal--customise-button" }, context.strings.customise_btn));
    }
    if (currentVariantObject && !currentVariantObject.sides.length) {
        return (React.createElement("button", { disabled: true, className: "btn btn--full hg-modal--customise-button" }, context.strings.customise_btn));
    }
    const updateCurrentVariant = (newVariant) => {
        const newVariantObj = context.product.variants.find((variant) => variant.options.filter((option, index) => option !== currentVariantObject.options[index]).length === 1 &&
            variant.options.includes(newVariant));
        const sizeOption = context.product.options.find((option) => option.name == 'Size');
        const colorOption = context.product.options.find((option) => option.name == 'Colour');
        let newFilterOpt = context.product.variants.filter((variant) => variant.options[sizeOption.position - 1] == newVariantObj.options[sizeOption.position - 1]);
        if (colorOption) {
            newFilterOpt = newFilterOpt.filter((variant) => variant.options[colorOption.position - 1] == newVariantObj.options[colorOption.position - 1] &&
                variant.options[sizeOption.position - 1] == newVariantObj.options[sizeOption.position - 1]);
        }
        setCurrentVariantObject(newVariantObj);
        setCurrentFilterOptions(newFilterOpt);
        // Click the PDP button to update gallery and URL
        const pdpVariantButton = document.querySelector(`[data-product-blocks] .variant-input[data-value="${newVariant}"] label`);
        if (pdpVariantButton) {
            pdpVariantButton.click();
        }
    };
    const templateStrings = JSON.parse(document.querySelector('[data-hg-customiser-template-strings]').textContent);
    return (React.createElement(React.Fragment, null,
        context &&
            ReactDOM.createPortal(React.createElement(CustomiseModal, Object.assign({ key: modalKey }, context, { display: modalDisplay, handler: buttonHandler, currentVariant: currentVariantObject, currentFilterOptions: currentFilterOptions, updateCurrentVariant: updateCurrentVariant, templateStrings: templateStrings })), document.querySelector(customiserContainerSelector)),
        React.createElement("button", { onClick: buttonHandler, className: "btn btn--full hg-modal--customise-button" }, context.strings.customise_btn)));
};
const preloadData = (customiserButtonSelector) => __awaiter(void 0, void 0, void 0, function* () {
    const productHandle = document.querySelector(customiserButtonSelector).dataset.product;
    const fetchedContext = yield fetch(`${window.Shopify.routes.root}products/${productHandle}?view=customiser.json`).then((data) => data.json());
    return fetchedContext;
});
const initCustomiser = () => __awaiter(void 0, void 0, void 0, function* () {
    const customiserButtonSelector = '[data-hg-customise-button]';
    const customiserContainerSelector = '[data-hg-customise-container]';
    const customiserButton = document.querySelector(customiserButtonSelector);
    if (customiserButton) {
        const context = yield preloadData(customiserButtonSelector);
        console.log('context', context);
        const root = createRoot(customiserButton);
        root.render(React.createElement(Customiser, { customiserButtonSelector: customiserButtonSelector, customiserContainerSelector: customiserContainerSelector, preloadContext: context }));
    }
});
export default initCustomiser;
